/**
 * Sets up the browser capabilities object
 * @module browser_capabilities
 */
/**
 * get an empty browser capabilities object
 * @returns {{...browserCapabilities}}
 */
export var getInitialCapabilities = function () {
    return {
        canUseBeacon: null,
        canUseCookies: null,
        canUseLocalStorage: null,
        canUseMutationObserver: null,
        canUsePostMessage: null,
        canUseXDomain: null,
        canUseXhr: null,
        canUseXhrCors: null
    };
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/@salecycle/client-script-core/src/browser_capabilities.js
// module id = 5
// module chunks = 0